import React from "react";

interface Props {
  label: string;
  hint?: string;
  children: React.ReactNode;
  className?: string;
}

export default function FormRow({ label, hint, children, className = "" }: Props) {
  return (
    <div className={`flex items-center justify-between gap-4 py-[var(--ds-row-padding-y)] ${className}`}>
      <div className="min-w-0">
        <span className="text-sm font-medium text-zinc-600 leading-none">{label}</span>
        {hint && <p className="text-xs text-zinc-400 mt-0.5">{hint}</p>}
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">{children}</div>
    </div>
  );
}
